var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Text, SkeletonLoader, Tooltip, } from "@merge-api/merge-javascript-shared";
import { LogoAvatar } from "./shared/LogoAvatar";
export var PromptSuggestionButton = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var suggestion = _a.suggestion, onClick = _a.onClick, onSuggestionSend = _a.onSuggestionSend, _h = _a.isLoading, isLoading = _h === void 0 ? false : _h;
    var isDisabled = (_b = suggestion === null || suggestion === void 0 ? void 0 : suggestion.isDisabled) !== null && _b !== void 0 ? _b : false;
    var disabledTooltip = isDisabled && ((_c = suggestion === null || suggestion === void 0 ? void 0 : suggestion.connector) === null || _c === void 0 ? void 0 : _c.name)
        ? "Add the ".concat(suggestion.connector.name, " connector to your Tool Pack")
        : undefined;
    var handleClick = function () {
        if (isDisabled || !suggestion) {
            return; // Do nothing when disabled or no suggestion
        }
        if (onSuggestionSend) {
            onSuggestionSend(suggestion.text);
        }
        else {
            onClick === null || onClick === void 0 ? void 0 : onClick(suggestion.text);
        }
    };
    var cardContent = (_jsx(Card, __assign({ variant: "outline", type: "button", onClick: handleClick, className: "w-full px-3 py-3 transition-colors ".concat(isDisabled
            ? "opacity-50 cursor-default"
            : "hover:bg-hover-bg cursor-pointer") }, { children: _jsx("div", __assign({ className: "flex flex-col items-start gap-y-2 w-full overflow-hidden" }, { children: isLoading ? (_jsxs(_Fragment, { children: [_jsx(SkeletonLoader, { height: 22, width: 22, borderRadius: 11 }), _jsx(SkeletonLoader, { height: 20, fullWidth: true, borderRadius: 4 })] })) : (_jsxs(_Fragment, { children: [_jsx(LogoAvatar, { src: (_e = (_d = suggestion === null || suggestion === void 0 ? void 0 : suggestion.connector) === null || _d === void 0 ? void 0 : _d.logo_url) !== null && _e !== void 0 ? _e : undefined, name: (_g = (_f = suggestion === null || suggestion === void 0 ? void 0 : suggestion.connector) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : "", size: 20, border: true, rounded: "rounded-full" }), _jsx(Text, __assign({ as: "div", variant: "sm", className: "text-gray-40 text-left truncate w-full" }, { children: suggestion === null || suggestion === void 0 ? void 0 : suggestion.text }))] })) })) })));
    if (isDisabled && disabledTooltip) {
        return _jsx(Tooltip, __assign({ title: disabledTooltip }, { children: cardContent }));
    }
    return cardContent;
};
